<template>
    <v-card flat>
        <v-card-title>
            Listado
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details>
            </v-text-field>
        </v-card-title>

        <v-data-table :headers="headers" :items="colores" :search="search" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc">
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="editColor(item.id_color)">mdi-pencil</v-icon>
                <v-icon small @click="showDeleteDialog(item)">mdi-delete</v-icon>
            </template>
        </v-data-table>

        <v-dialog v-model="dialogDelete" persistent max-width="500px">
            <v-card>
                <v-card-title class="text-h5">
                    {{ itemToDelete.nombre }}
                    ({{ itemToDelete.ref }})
                </v-card-title>
                <v-card-text>¿Estás seguro de querer borrar el Color?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="dialogDelete = false">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" text @click="deleteColor(itemToDelete.id_color)">
                        Borrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import ColoresDataService from "@/services/ColoresDataService";

export default {
    name: "ColoresList",
    data: () => ({
        colores: [],
        search: '',
        sortBy: 'nombre',
        sortDesc: false,
        headers: [
            { text: 'Nombre', value: 'nombre' },
            { text: 'Referencia', value: 'referencia' },
            { text: 'RAL', value: 'ral' },
            { text: "Actions", value: "actions", sortable: false },
        ],
        dialogDelete: false,
        itemToDelete: {},
    }),
    methods: {
        retrieveColores() {
            ColoresDataService.getAll()
                .then((response) => {
                    // console.log("COLORES"); console.log(response.data);
                    this.colores = response.data.map(this.getDisplayColor);
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        editColor(id) {
            this.$router.push({ name: "ColorId", params: { id: id } });
        },
        deleteColor(id) {
            ColoresDataService.delete(id)
                .then(() => {
                    this.retrieveColores();
                    this.dialogDelete = false
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        getDisplayColor(color) {
            return {
                id_color: color.id_color,
                ref: color.referencia,
                nombre: color.nombre,
                referencia: color.referencia,
                ral: color.ral,
            };
        },
        showDeleteDialog(item) {
            this.itemToDelete = item
            this.dialogDelete = !this.dialogDelete
        },
    },
    mounted() {
        this.retrieveColores();
    }
};
</script>